import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { CustomContentView } from '@confluence/custom-content-view/entry-points/CustomContentView';

export const CustomContentViewRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => {
	return <CustomContentView spaceKey={spaceKey} contentId={contentId} />;
};

CustomContentViewRoute.NAVIGATION_PARAMS = ({
	name,
	params: { contentId, spaceKey },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'customContentView',
			id: contentId,
		},
		pageState: {
			routeName: name,
			spaceKey,
			contentId,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
	},
});
